import { getCsrfValue } from "~/common/utils/ApiHelper";

import { resolveApiUrl } from "~/utils/url/urlResolver";
import { type SavedConfigurationDTO } from "~/features/configurator/Linear/dtos";

export function sendLinearSaveConfig(
  productCode: string,
  configId: string,
  name: string,
  currentStep: number,
): Promise<SavedConfigurationDTO> {
  const apiUrl = resolveApiUrl(`/${productCode}/configuratorPage/LinearConfigurator/save`);

  const data = {
    id: configId,
    name,
    currentStep,
  };

  return fetch(apiUrl, {
    body: JSON.stringify(data),
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
    redirect: "follow",
  }).then((result) => {
    if (result.ok) {
      return result.json();
    } else {
      console.error(`Error sending linear update: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
